import { Component, inject } from '@angular/core';
import { MachineHeaderChangeHistoricService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  MachineHeaderChangeHistoricCreateDto,
  MachineHeaderChangeHistoricDto,
  MachineHeaderChangeHistoricExcelDownloadDto,
  MachineHeaderChangeHistoricUpdateDto,
} from '../proxy/general/dtos/machine-header-change-historic';
import { MACHINEHEADERCHANGEHISTORIC_CONFIG, MACHINEHEADERCHANGEHISTORIC_FIELDS } from './machine-header-change-historic.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-machine-header-change-historic',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, MachineHeaderChangeHistoricService, ConfirmationService],
  templateUrl: './machine-header-change-historic.html',
  styleUrl: './machine-header-change-historic.scss',
})
export class MachineHeaderChangeHistoric extends BaseHierarchicalCrudComponent<
  MachineHeaderChangeHistoricDto,
  MachineHeaderChangeHistoricCreateDto,
  MachineHeaderChangeHistoricUpdateDto,
  MachineHeaderChangeHistoricExcelDownloadDto
> {
  service = inject(MachineHeaderChangeHistoricService);
  config = MACHINEHEADERCHANGEHISTORIC_CONFIG;
  fields = MACHINEHEADERCHANGEHISTORIC_FIELDS;

  protected prepareUpdateDto(data: any, selected: MachineHeaderChangeHistoricDto): MachineHeaderChangeHistoricUpdateDto {
    return {
      dateFrom: data.dateFrom,
      dateTo: data.dateTo,
      machineId: data.machineId,
      headerId: data.headerId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'MachineHeaderChangeHistoric';
  }
}
